import React from 'react';
import {StringParam, useQueryParam} from 'use-query-params';
import MediaTabs from './MediaTabs';
import Constants from '../../constants/Constants';

const MediaTabWrapper: React.FC = () => {
   const [tab, setTab] = useQueryParam(Constants.queryParams.tab, StringParam);

   return (
      <MediaTabs tab={tab} setTab={v => setTab(v, 'replaceIn')} />
   );
};

export default MediaTabWrapper;
